import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API_URL = `${BACKEND_URL}/api`;

function getHashParams() {
  const hash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash;
  return new URLSearchParams(hash);
}

function getSafeRedirect(params) {
  const redirect = params.get('redirect') || '/overview';
  return redirect.startsWith('/') && !redirect.startsWith('//') ? redirect : '/overview';
}

export default function SSOPage() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const startedRef = useRef(false);

  useEffect(() => {
    const completeSSO = async () => {
      if (startedRef.current) return;
      startedRef.current = true;

      const params = getHashParams();
      const token = params.get('token');
      const redirect = getSafeRedirect(params);
      window.history.replaceState({}, document.title, window.location.pathname);

      if (!token) {
        setError('Missing SSO token.');
        return;
      }

      try {
        const response = await fetch(`${API_URL}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
          throw new Error('SSO token was rejected.');
        }

        const user = await response.json();
        localStorage.setItem('eva_token', token);
        localStorage.setItem('eva_user', JSON.stringify(user));
        if (user.tenant) {
          localStorage.setItem('eva_tenant', JSON.stringify(user.tenant));
        } else {
          localStorage.removeItem('eva_tenant');
        }
        localStorage.removeItem('eva_viewing_as_superadmin');

        window.location.replace(redirect);
      } catch (err) {
        console.error('Eva Insights SSO failed:', err);
        localStorage.removeItem('eva_token');
        localStorage.removeItem('eva_user');
        localStorage.removeItem('eva_tenant');
        setError('Unable to sign you in automatically.');
      }
    };

    completeSSO();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="rounded-2xl border border-border bg-card p-8 text-center shadow-xl">
        {!error ? (
          <>
            <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-muted border-t-primary" />
            <p className="text-sm font-medium text-foreground">Opening Eva Insights...</p>
          </>
        ) : (
          <>
            <p className="font-semibold text-foreground">SSO failed</p>
            <p className="mt-2 text-sm text-muted-foreground">{error}</p>
            <button
              type="button"
              onClick={() => navigate('/login', { replace: true })}
              className="mt-5 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:bg-primary/90"
            >
              Go to login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
